import { useFormik } from "formik";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getExcelFormData, updateForm } from "../../api";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  updateConfig,
  getQcPendingList,
  getQcCompletedList,
  getQcMarkedList,
  getQcRejectedList,
} from "../../../../../store/slices/QC/QCSlice";

const useVersionTwo = () => {
  const {
    item,
    typeFormData,
    excelEditedFormData,
    dropdownValues,
    itemID,
    data,
    activeId,
    cnfModal,
    certificateID,
    excelFormData,
    certificateNumber,
    assignedID,
    formData,
  } = useSelector((state) => state.qc);
  const slug = sessionStorage?.getItem("slug");
  const dispatch = useDispatch();
  useEffect(() => {
    handleReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeId]);

  const currentTab = data?.filter(
    (value) => value?.name === `Version ${activeId}`
  );

  const handleReset = () => {
    const data =
      excelEditedFormData?.length > 0
        ? excelEditedFormData?.[
            !currentTab?.[0]?.disabled
              ? excelEditedFormData?.length - 1
              : activeId - 2
          ]?.data
        : excelFormData?.data;
    data?.map((value) => formik?.setFieldValue(`${value?.slug}`, value?.value));

    const sideData =
      excelEditedFormData?.length > 0
        ? excelEditedFormData?.[
            !currentTab?.[0]?.disabled
              ? excelEditedFormData?.length - 1
              : activeId - 2
          ]?.side_stone
        : excelFormData?.side_stone;

    const centerData =
      excelEditedFormData?.length > 0
        ? excelEditedFormData?.[
            !currentTab?.[0]?.disabled
              ? excelEditedFormData?.length - 1
              : activeId - 2
          ]?.center_stone
        : excelFormData?.center_stone;

    sideData?.map((value) =>
      formik?.setFieldValue(`side_stone_${value?.slug}`, value?.value)
    );
    centerData?.map((value) =>
      formik?.setFieldValue(`center_stone_${value?.slug}`, value?.value)
    );
  };

  // const formik = useFormik({
  //   initialValues: {

  //     group:[
  //       {
  //         type: "",
  //         count: "",
  //         percentage: "",
  //         others: "",
  //       },
  //     ]
  //   },

  const formik = useFormik({
    initialValues: {
      group: excelFormData?.[
        excelFormData?.marked
          ? "marked"
          : excelFormData?.rejected
          ? "rejected"
          : ""
      ]
        ? excelFormData[
            excelFormData.marked
              ? "marked"
              : excelFormData.rejected
              ? "rejected"
              : ""
          ].map((item) => ({
            type: item?.type || "",
            count: item?.count || "",
            percentage: item?.percentage || "",
            others: item?.others || "",
          }))
        : [
            {
              type: "",
              count: "",
              percentage: "",
              others: "",
            },
          ],
    },

    validate: (values) => {
      let errors = {};

      // Add other field-level validations here if required

      if (values.status !== 2 && Array.isArray(values.group)) {
        const groupErrors = values.group.map((item, index) => {
          const itemErrors = {};
          if (!item.type) itemErrors.type = "Type is required";
          // if (!item.count) itemErrors.count = "Count is required";
          // if (!item.percentage)
          //   itemErrors.percentage = "Percentage is required";
          return Object.keys(itemErrors).length > 0 ? itemErrors : null;
        });

        if (groupErrors.some(Boolean)) {
          errors.group = groupErrors;
        }
      }

      return errors;
    },

    onSubmit: (values) => {
      let data = {
        process_slug: slug,
        item_details_id: certificateID,
        ...values,
      };
      let formDatas = new FormData();
      for (let key in data) {
        if (key.startsWith("center_stone")) {
          const formattedKey = key.replace("center_stone_", ""); // Remove the prefix
          formDatas.append(`center_stone[${formattedKey}]`, data[key]);
        } else if (key.startsWith("side_stone")) {
          const formattedKey = key.replace("side_stone_", ""); // Remove the prefix
          formDatas.append(`side_stone[${formattedKey}]`, data[key]);
        } else if (key === "group") {
          data?.group?.forEach((item, index) => {
            // ["count", "others", "percentage", "type"].forEach((field) => {
            //   formData.append(`marked.[${index}].${field}`, item?.[field]);
            // });
            let rowKey =
              values?.status === 5
                ? "marked"
                : values?.status === 4
                ? "rejected"
                : "";

            // values?.status === 9 ? "recheck"
            if (rowKey) {
              ["count", "others", "percentage", "type"].forEach((field) => {
                formDatas.append(
                  `${rowKey}[${index}][${field}]`,
                  item?.[field]
                );
              });
              let type = typeFormData?.dropdown_values?.type?.filter(
                (typ) => typ?.name === item?.type
              );
              formDatas?.append(`${rowKey}[${index}][type_id]`, type?.[0]?.id);
            }
          });
        } else {
          // For other keys, append them as they are
          formDatas.append(key, data[key]);
        }
      }
      updateForm(formDatas).then((response) => {
        if (response?.data?.status_code === 200) {
          toast.success("Data updated ");
          dispatch(
            updateConfig((state) => {
              state.certificateID = item?._id;
              state.itemID = item?.gli_number;
              state.showCompare = false;
            })
          );
          let data = {
            item_details_id: item?._id,
            item_type_id: item?.item_type_id,
            process_slug: slug,
          };
          getExcelFormData(data)
            .then((response) => {
              if (response?.data?.status_code === 200) {
                // handleReset();
                handleModal();
                if (response?.data?.data?.updated_values.length !== 0) {
                  const newData = response.data.data.updated_values.map(
                    (_, index) => ({
                      name: `Version ${index + 2}`,
                    })
                  );
                  dispatch(
                    updateConfig((state) => {
                      state.data = [{ name: "Version 1" }, ...newData].map(
                        (version) => ({
                          ...version,
                          disabled: true, // Set the 'disabled' property to true for all versions
                        })
                      );
                    })
                  );
                }
                dispatch(
                  updateConfig((state) => {
                    state.excelFormData = response?.data?.data?.graded_values;
                    state.excelEditedFormData =
                      response?.data?.data?.updated_values.length === 0
                        ? (state.excelFormData =
                            response?.data?.data?.graded_values)
                        : response?.data?.data?.updated_values;
                    state.showValues = true;
                    state.showForm = false;
                  })
                );

                 dispatch(
                   updateConfig((state) => {
                     state.qcData.Passed = [];
                     state.qcData.Pending = [];
                     state.qcData.Marked = [];
                     state.qcData.Rejected = [];
                     state.showValues = false;
                     state.showForm = false;
                     state.showGli = true;
                   })
                 );

                 dispatch(
                            getQcPendingList({
                              page: 1,
                              per_page: 10,
                              receipt_id: assignedID,
                              process_slug: slug,
                            })
                          );
                          dispatch(
                            getQcCompletedList({
                              page: 1,
                              per_page: 10,
                              receipt_id: assignedID,
                              process_slug: slug,
                            })
                          );
                          dispatch(
                            getQcMarkedList({
                              page: 1,
                              per_page: 10,
                              receipt_id: assignedID,
                              process_slug: slug,
                              status: 5,
                            })
                          );
                          dispatch(
                            getQcRejectedList({
                              page: 1,
                              per_page: 10,
                              receipt_id: assignedID,
                              process_slug: slug,
                              status: 4,
                            })
                          );
              }
            })
            .catch((error) => toast.error(error));
        } else if (response?.status_code === 422) {
          const errors = response.errors;
          formik.setErrors(errors);
        } else {
          toast.error("Something went wrong");
        }
      });
    },
  });

  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };

  const handleModal = () => {
    dispatch(updateConfig((state) => (state.cnfModal = !state.cnfModal)));
  };

  const handleYes = () => {
    dispatch(
      updateConfig((state) => {
        state.showVersionTwoTable = true;
        state.cnfModal = false;
      })
    );
  };

  return {
    formik,
    formData,
    dropdownValues,
    excelEditedFormData,
    excelFormData,
    itemID,
    data,
    activeId,
    certificateNumber,
    currentTab,
    cnfModal,
    typeFormData,
    handleYes,
    handleModal,
    getFieldError,
    handleReset,
  };
};

export default useVersionTwo;
